import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import Dialog from '../../../components/dialog/dialog.component'
import Loading from '../../../components/loading/loading.component'
import { connect } from 'react-redux'
import iconNew from '../../../assets/icons/new-light.svg'
import Pagination from '../../../components/pagination/pagination.component'
import './naslist.styles.scss'
import Service from './naslist.service'
import iconDelete from '../../../assets/icons/delete-red.svg'
import iconEdit from '../../../assets/icons/edit-dark.svg'
import DeleteNas from './components/delete/delete.component'

class NasList extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    componentDidMount() {
        this.service.loadNasList()
    }

    onPageChange = page => {
        this.setState({
            ...this.state,
            currentPage: page
        }, () => this.service.loadNasList())
    }

    onFilterChange = e => {
        this.setState({
            ...this.state,
            filter: {
                ...this.state.filter,
                value: "",
                [e.target.name]: e.target.value
            }
        })
    }

    onFilterSubmit = e => {
        e.preventDefault()
        this.service.loadNasList()
    }

    toggleShowDelete = nas => this.setState({
        ...this.state,
        showDelete: !this.state.showDelete,
        nasToDelete: nas
    })

    onDelete = () => this.setState({
        ...this.state,
        showDelete: false,
        nasList: this.state.nasList.filter(nas => nas.id !== this.state.nasToDelete.id)
    })

    render() {
        return (
            <>
                {this.state.loadingNasList && <Dialog><Loading /></Dialog>}
                {this.state.showDelete && <Dialog><DeleteNas nas={this.state.nasToDelete} onDelete={this.onDelete} onCancel={() => this.toggleShowDelete(null)} /></Dialog>}
                <div className="naslist">
                    <div className="header">
                        <h4>Nas</h4>
                        <div className="buttons">
                            <Link className="btn" to="/internet/nas/create"><img alt="" src={iconNew} />New Nas</Link>
                        </div>
                    </div>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>IP Address</th>
                                <th>Port</th>
                                <th>Description</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.state.nasList.map((nas, key) => <tr key={key}>
                                    <td>{nas.shortname}</td>
                                    <td>{nas.nasname}</td>
                                    <td>{nas.ports}</td>
                                    <td>{nas.description}</td>
                                    <td>
                                        <div className="actions">
                                            <img alt="" src={iconEdit} onClick={() => this.props.history.push('/internet/nas/' + nas.id)} />
                                            <img alt="" src={iconDelete} onClick={() => this.toggleShowDelete(nas)} />
                                        </div>
                                    </td>
                                </tr>)
                            }
                        </tbody>
                    </table>
                    {
                        this.state.total > 0 && <Pagination totalItemsCount={this.state.total} currentIndex={this.state.currentPage} itemsPerPage={this.state.pageSize} onChange={this.onPageChange} />
                    }
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(NasList))